export default __webpack_public_path__ + "static/media/alert-icon-12.fb034609.svg";